module.exports = __webpack_public_path__ + "static/media/parent-disney_50.01f6f768.png";